export function getTodayIso(now = new Date()): string {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(
    now.getDate()
  ).padStart(2, "0")}`;
}

export function buildCurrentDateContextPrompt(now = new Date()): string {
  return `## Current Date Context

Today's date is ${getTodayIso(now)}.
When writing research queries, choosing date ranges, or deciding what information is current, resolve relative periods against today's date. Do not default to stale historical end years such as 2024 unless the user or provided context explicitly asks for that period.`;
}
